import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { FilterOrderBatchInput } from './FilterOrderBatchInput';
import { FilterOrderBatchOutput } from './FilterOrderBatchOutput';

export class FilterOrderBatchService extends HttpServiceBase {

  handle = (input?: FilterOrderBatchInput): Promise<Result<FilterOrderBatchOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<FilterOrderBatchOutput>>(`${this.baseUrlSislogApi}/v2/order/batch/filtered${parameters}`);
    return promise;
  }
}